import React from "react";
import styled from "styled-components";
import Container from "../Container";
import Row from "../Row";
import ButtonTestFree from "../ButtonTestFree";
import BannerFollow from "../../assets/images/mock_follow.svg";
import { Icon } from "@iconify/react";

interface NicheFollowUpProps {
  title: string;
  subtitle: string;
  items: string[];
}

const SectionTitle = styled.h2`
  font-weight: 200;
  font-size: 40px;
  margin: 0 0 40px;
  color: #ffffff;
  text-align: left;
  line-height: 56px;

  span {
    color: #e4da1b;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 40px;
  }
`;

const Subtitle = styled.p`
  font-size: 20px;
  font-weight: 200;
  line-height: 30px;
  color: #ffffff;
  margin: 0 0 40px;
  text-align: left;
`;

const StrategyList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 0;
  margin: 0 0 40px;
  list-style: none;
`;

const StrategyItem = styled.li`
  display: grid;
  grid-template-columns: 27px 1fr;
  gap: 16px;
  align-items: flex-start;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
`;

const ResponsiveImage = styled.img`
  width: 100%;
  height: auto;
  float: right;
`;

const NicheFollowUp: React.FC<NicheFollowUpProps> = ({ title, subtitle, items }) => (
  <Container style={{ background: "#000000", paddingTop: "80px", paddingBottom: "80px" }}>
    <Row
      xs="1fr"
      sm="1fr"
      md="1fr 38%"
      lg="1fr 38%"
      xl="1fr 38%"
      style={{ alignItems: "center" }}
    >
      <div>
        <SectionTitle>
          {title.split("Alfred").map((part, i, arr) =>
            i < arr.length - 1 ? (
              <React.Fragment key={i}>
                {part}
                <span>Alfred</span>
              </React.Fragment>
            ) : (
              part
            )
          )}
        </SectionTitle>
        <Subtitle>{subtitle}</Subtitle>
        <StrategyList>
          {items.map((item) => (
            <StrategyItem key={item}>
              <Icon icon="mdi:check-circle" color="#e4da1b" width={27} height={27} style={{ marginTop: 2 }} />
              <span>{item}</span>
            </StrategyItem>
          ))}
        </StrategyList>
        <ButtonTestFree />
      </div>
      <div>
        <ResponsiveImage src={BannerFollow} alt="follow-up" />
      </div>
    </Row>
  </Container>
);

export default NicheFollowUp;
